export function AnalyticsGraph({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="148"
        height="186"
        viewBox="0 0 148 186"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_3284_33192)">
          <rect x="0.925293" width="142.15" height="180" rx="18.0115" fill="#F6F6F6" />
        </g>
        <g clipPath="url(#clip0_3284_33192)">
          <path
            d="M77.2409 60.1505C91.8038 62.5959 102.374 75.076 102.374 89.8257C102.374 96.094 100.432 102.126 96.7589 107.271C96.3861 107.794 96.2106 108.431 96.2636 109.07C96.3165 109.71 96.5946 110.309 97.0482 110.763L104.85 118.565C106.003 119.717 107.904 119.599 108.906 118.313C115.301 110.093 118.682 100.242 118.682 89.8257C118.682 66.4443 101.203 46.6401 78.0241 43.7594C76.407 43.5585 74.979 44.8196 74.979 46.4493V57.4773C74.979 58.1184 75.2063 58.7387 75.6204 59.2281C76.0345 59.7175 76.6087 60.0444 77.2409 60.1505Z"
            fill="#44AAF2"
          />
          <path
            d="M26.18 84.0476C25.9791 85.6647 27.2402 87.0925 28.8699 87.0925H39.8979C40.5389 87.0925 41.1592 86.8652 41.6486 86.4512C42.138 86.0371 42.4648 85.463 42.5709 84.8308C44.6934 72.191 54.6114 62.2728 67.2512 60.1505C67.8834 60.0443 68.4576 59.7175 68.8716 59.2281C69.2857 58.7387 69.5129 58.1184 69.5129 57.4773V46.4493C69.5129 44.8196 68.0853 43.5585 66.468 43.7594C56.2994 45.0231 46.6933 49.725 39.4193 56.9988C32.1456 64.2727 27.4437 73.8788 26.18 84.0476Z"
            fill="#FED330"
          />
          <path
            d="M89.692 114.337C84.5472 118.01 78.5146 119.952 72.2463 119.952C57.4966 119.952 45.0165 109.382 42.5711 94.8188C42.4649 94.1866 42.1382 93.6125 41.6488 93.1984C41.1594 92.7843 40.5391 92.5571 39.898 92.557H28.8699C27.2402 92.557 25.9791 93.9846 26.18 95.6018C29.0607 118.781 48.8649 136.26 72.2463 136.26C82.6624 136.26 92.5129 132.879 100.733 126.483C102.02 125.482 102.138 123.58 100.985 122.427L93.1839 114.626C92.7302 114.172 92.1304 113.894 91.491 113.841C90.8516 113.788 90.2142 113.964 89.692 114.337Z"
            fill="#A55EEA"
          />
          <path
            d="M74.0498 71.1971H70.4335C68.9365 71.1971 67.7228 72.4108 67.7228 73.9078V105.532H76.7605V73.9078C76.7605 72.4108 75.5468 71.1971 74.0498 71.1971ZM82.1818 105.532H88.5088C90.0058 105.532 91.2194 104.318 91.2194 102.821V81.136C91.2194 79.639 90.0058 78.4253 88.5088 78.4253H82.1818V105.532ZM62.3015 85.6537H55.9814C54.4844 85.6537 53.2708 86.8674 53.2708 88.3644V102.821C53.2708 104.318 54.4844 105.532 55.9814 105.532H62.3015V85.6537Z"
            fill="#EB3B59"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_3284_33192"
            x="0.925293"
            y="0"
            width="146.355"
            height="185.047"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="4.20561" dy="5.04673" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.396078 0 0 0 0 0.729412 0 0 0 0 0.776471 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_3284_33192"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_3284_33192"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_3284_33192">
            <rect
              width="92.5234"
              height="92.5234"
              fill="white"
              transform="translate(26.1589 43.7383)"
            />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
